var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type)?_c('div',{staticClass:"label-box"},[_vm._v(" "+_vm._s(_vm.types[this.type])+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }